//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ScrollableContainer from "@Shared/components/general/scrollable-container";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NavBar",
  components: {
    ScrollableContainer
  },
  props: {
    currentTab: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    },
    scrollClass: {
      type: String,
      default: ""
    },
    containerClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleTabChange(val) {
      this.$emit("tab-change", val);
    }
  }
});